// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"dec748b4","453":"1a4a3e0f"}[chunkId] + ".chunk.js";
};